/** @jsx jsx */
import { Box, Container, Grid, Heading, jsx, Text } from 'theme-ui'
import ArticlePrimaryFeaturedCard from '~/components/Article/PrimaryFeaturedCard'
import ArticleSecondaryFeaturedCard from '~/components/Article/SecondaryFeaturedCard'

const FeaturedArticlesSection = ({ articles, description, title }) => {
  return (
    <Box pt={[5, 7, 9]} pb={[7, 8, 10]}>
      <Container>
        <Grid columns={[1, 12]}>
          <Box
            sx={{ gridColumn: [null, '2 / 12', '3 / 11'], textAlign: 'center' }}
          >
            <Heading as="h1" variant="title1" mb={2}>
              {title}
            </Heading>
            {description && (
              <Box
                variant="text.body1"
                sx={{
                  p: {
                    m: 0,
                  },
                  a: {
                    variant: 'text.link',
                  },
                }}
                dangerouslySetInnerHTML={{
                  __html: description.childMarkdownRemark.html,
                }}
              />
            )}
          </Box>
        </Grid>
        {articles && (
          <Box mt={[6, null, 7]}>
            <Text
              as="h2"
              bg="backgroundMedium"
              ml={['-16px', '-24px']}
              mb={[2, 3]}
              py="10px"
              pl={[4, 13, 6, 7]}
              pr={[2, 4]}
              variant="callout1"
              sx={{
                display: 'inline-block',
              }}
            >
              {'Our top picks'}
            </Text>
            <Grid columns={[1, 12, 2]}>
              <Box sx={{ gridColumn: [null, '2 / 12', '1 / 2'] }}>
                <ArticlePrimaryFeaturedCard article={articles[0]} />
              </Box>
              {articles.length > 1 && (
                <Box
                  mt={[3, 0]}
                  sx={{ gridColumn: [null, '2 / 12', '2 / -1'] }}
                >
                  {articles.slice(1, 4).map((article, index) => (
                    <Box key={index} mb={index !== 2 ? 3 : null}>
                      <ArticleSecondaryFeaturedCard article={article} />
                    </Box>
                  ))}
                </Box>
              )}
            </Grid>
          </Box>
        )}
      </Container>
    </Box>
  )
}

export default FeaturedArticlesSection
